import _ from "lodash";
import StatsConfigs from "../../../configs/stats";
import coreFilter from "./../core/filters";

/**
 * get current filters
 * returns each values from selected filters
 * @param state
 * @param ignoreFilter
 * @param globalIfDimEmpty load global data if dimension has no values
 * @return {}
 */
const getCurrentFilters = (state, ignoreFilter = null, globalIfDimEmpty = false) => {
  const stats = state.stats || {};
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || -1;

  const statsFilters = stats.filters || {};

  const statsFiltersSelected = statsFilters || {};
  statsFiltersSelected["client_id"] = { values: [currentClientId] };

  //if dimension selected, split by dimension
  const dimension = getCurrentDimensionSelected(state);
  let dimensionId = dimension.id;

  //prenvent splitted query when dimension filter is empty --> convert to globale
  const dimensionFilter = statsFiltersSelected[dimensionId] || {};
  const dimensionValues = dimensionFilter.values || [];
  if (globalIfDimEmpty && dimensionValues.length === 0) {
    dimensionId = "globale";
  }

  let split = false;

  if (!ignoreFilter && dimension && dimensionId !== "globale") {
    split = true;
    ignoreFilter = dimension.id;
  }
  if (!split) {
    return getCurrentFiltersUnSplitted(state, ignoreFilter);
  } else {
    return getCurrentFiltersSplitted(state, ignoreFilter);
  }
};

/**
 * get current filters, split by dimensions
 * returns each values from selected filters
 * @param state
 * @param ignoreFilter
 * @return {}
 */
const getCurrentFiltersSplitted = (state, ignoreFilter) => {
  const stats = state.stats || {};
  const kpis = stats.kpis || [];
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || -1;

  const statsFilters = stats.filters || {};
  const currentFilters = {};

  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = /*kpiSelected +*/ mainFilterSelected;

  const statsFiltersSelected = statsFilters; //statsFilters[filterKey] || {};
  statsFiltersSelected["client_id"] = { values: [currentClientId] };

  //if dimension selected, split by dimension
  for (const [key, { values = [] }] of Object.entries(statsFiltersSelected)) {
    if (key && key !== ignoreFilter && Array.isArray(values) && values.length > 0) {
      currentFilters[key] = values;
    }
  }

  //build splitted filters
  const dimensionsFilters = [];
  const statsFilter = statsFiltersSelected[ignoreFilter] || {};

  const statsFilterValues = statsFilter.values || [];
  const statsFilterData = statsFilter.dataSelected || [];

  const kpi = kpis.find(v => v.id === kpiSelected);
  const currentKpiFilters = coreFilter.extractFilters(currentFilters, kpi);
  const defaultFilters = coreFilter.getDefaultFilters(kpi);
  for (let i = 0; i < statsFilterValues.length; i++) {
    const statsFilterValue = statsFilterValues[i];
    const statsFilterValueObj = _.find(statsFilterData, { id: statsFilterValue }) || {};
    dimensionsFilters.push({
      id: statsFilterValueObj.value || "Globale",
      data: {
        ...defaultFilters,
        [ignoreFilter]: [statsFilterValue],
        ...currentKpiFilters
      }
    });
  }

  return dimensionsFilters;
};

/**
 * get current filters, not splitted
 * returns each values from selected filters
 * @param state
 * @param ignoreFilter
 * @return {}
 */
const getCurrentFiltersUnSplitted = (state, ignoreFilter) => {
  const stats = state.stats || {};
  const kpis = stats.kpis || [];
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || -1;

  const statsFilters = stats.filters || {};
  const currentFilters = {};

  const kpiSelected = stats.kpiSelected;

  const statsFiltersSelected = statsFilters || {};
  statsFiltersSelected["client_id"] = { values: [currentClientId] };

  //if dimension selected, split by dimension
  const dimension = getCurrentDimensionSelected(state);

  for (const [key, { values = [] }] of Object.entries(statsFiltersSelected)) {
    if (key && key !== ignoreFilter && Array.isArray(values) && values.length > 0) {
      currentFilters[key] = values;
    }
  }

  const kpi = kpis.find(v => v.id === kpiSelected);
  const currentKpiFilters = coreFilter.extractFilters(currentFilters, kpi);
  const defaultFilters = coreFilter.getDefaultFilters(kpi);
  return {
    id: dimension.label,
    data: {
      ...defaultFilters,
      ...currentKpiFilters
    }
  };
};

/**
 * get  selected filter data
 * @param state
 * @return {}
 */
const getSelectedFilter = state => {
  const stats = state.stats || {};
  const statsFilters = stats.filters || {};
  const subfilterSelected = stats.subfilterSelected;
  const statsFiltersSelected = statsFilters || {};
  return statsFiltersSelected[subfilterSelected] || {};
};

/**
 * Get main filter (object) selected
 * @param state
 * @return {*}
 */
const getCurrentDimensionSelected = state => {
  const stats = state.stats || {};
  const mainFilterSelected = stats.mainFilterSelected;
  const dimensions = StatsConfigs.dimensions;

  const mainFilter = _.find(dimensions, { id: mainFilterSelected }) || dimensions[0];
  return mainFilter || {};
};

/**
 * get current data
 * @param state
 * @return {Array}
 */
const getCurrentData = state => {
  const stats = state.stats || {};
  const statsData = stats.data || {};
  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = kpiSelected + mainFilterSelected;

  const statFilterKey = statsData[filterKey] || {};
  return statFilterKey.results || [];
};

/**
 * get current dashboard data
 * @param state
 * @return {Array}
 */
const getCurrentDashboardData = state => {
  const stats = state.stats || {};
  const statsData = stats.dashboardData || {};
  const kpiSelected = stats.kpiSelected;
  //console.log("dashboardData", statsData)
  //console.log("kpiSelected", statsData)

  return statsData[kpiSelected] || {};
};

/**
 * get current table data
 * @param state
 * @return {Array}
 */
const getCurrentTableData = state => {
  const stats = state.stats || {};
  const statsData = stats.tableData || {};
  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = kpiSelected + mainFilterSelected;

  return statsData[filterKey] || [];
};

/**
 * get current summaryData data
 * @param state
 * @return {Array}
 */
const getCurrentSummaryData = state => {
  const stats = state.stats || {};
  const statsData = stats.summaryData || {};
  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = kpiSelected + mainFilterSelected;
  return statsData[filterKey] || [];
};

/**
 * get current home data
 * @param state
 * @return {}
 */
const getCurrentHomeData = state => {
  const stats = state.stats || {};
  return stats.homeData || {};
};

/**
 * get current data
 * @param state
 * @return {Array}
 */
const getCurrentCompiledData = state => {
  const stats = state.stats || {};
  const statsData = stats.data || {};
  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = /*kpiSelected +*/ mainFilterSelected;

  const statFilterKey = statsData[filterKey] || {};
  return statFilterKey.results_compiled || statFilterKey.results || [];
};

/**
 * get current statObj
 * @param state
 * @return {Array}
 */
const getCurrentStatsObj = state => {
  const stats = state.stats || {};
  const statsData = stats.data || {};
  const kpiSelected = stats.kpiSelected;
  const mainFilterSelected = stats.mainFilterSelected;
  const filterKey = kpiSelected + mainFilterSelected;

  const statFilterKey = statsData[filterKey] || {};
  return statFilterKey;
};

/**
 * get current filter obj
 * @param state
 * @return {Array}
 */
const getCurrentFilterObj = state => {
  const stats = state.stats || {};
  const statsData = stats.filters || {};

  const kpis = stats.kpis || [];
  const kpiSelected = stats.kpiSelected;
  const kpi = kpis.find(v => v.id === kpiSelected);
  return coreFilter.extractFilters(statsData, kpi);
};
/**
 * get current kpi.id selected
 * @param state
 * @return {object}
 */
const getKpiId = state => {
  const stats = state.stats || {};
  return stats.kpiSelected;
};

/**
 * get current kpi selected
 * @param state
 * @return {object}
 */
const getKpiSelected = state => {
  const stats = state.stats || {};
  const kpis = stats.kpis || [];
  const kpiSelected = stats.kpiSelected;

  return _.find(kpis, { id: kpiSelected });
};

/**
 * getall kpis
 * @param state
 * @return {object}
 */
const getAllKpis = state => {
  const stats = state.stats || {};
  return stats.kpis || [];
};

/**
 * get stats.tableLoading flag
 * @param state
 * @return {object}
 */
const getTableLoading = state => {
  const stats = state.stats || {};
  return stats.tableLoading;
};

const getSummaryDimensions = state => {
  return state.stats.summaryDimensions || [];
};

const getSummaryKpiId = state => {
  return state.stats.summaryKpi;
};

const getSummaryKpiSelected = state => {
  const stats = state.stats || {};
  const kpis = stats.kpis || [];
  const kpiSelected = stats.summaryKpi;

  return _.find(kpis, { id: kpiSelected }) || {};
};

const getSummaryDisplayType = state => {
  const stats = state.stats || {};
  return stats.summaryDisplayType;
};
const getCompareMode = state => {
  const stats = state.stats || {};
  return !!stats.periodToCompare;
};

const getIsDataDisplayed = state => {
  const stats = state.stats || {};
  return stats.isDataDisplayed;
};

export {
  getCurrentHomeData,
  getCurrentDashboardData,
  getCurrentTableData,
  getCurrentSummaryData,
  getCurrentFilters,
  getCurrentFiltersUnSplitted,
  getCurrentData,
  getKpiSelected,
  getCurrentDimensionSelected,
  getSelectedFilter,
  getCurrentCompiledData,
  getCurrentStatsObj,
  getCurrentFilterObj,
  getTableLoading,
  getSummaryDimensions,
  getSummaryKpiId,
  getAllKpis,
  getSummaryKpiSelected,
  getKpiId,
  getSummaryDisplayType,
  getCompareMode,
  getIsDataDisplayed
};



// WEBPACK FOOTER //
// src/modules/stats/selectors/index.js